const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M24.992 27.68h-18.304q-2.752 0-4.736-1.952t-1.952-4.736q0-2.304 1.408-4.096t3.584-2.336v-0.256q0-4.16 2.944-7.072t7.072-2.912q3.2 0 5.76 1.856t3.648 4.864q3.68-0.288 6.272 2.176t2.624 6.112q0 3.424-2.432 5.888t-5.888 2.464zM6.528 17.632q-1.28 0-2.24 0.992t-0.96 2.368 0.96 2.336 2.4 0.992h18.304q2.080 0 3.552-1.472t1.472-3.52-1.472-3.552-3.552-1.472q-0.576 0-1.344 0.256l-1.792 0.512-0.288-1.824q-0.448-2.4-2.272-4t-4.288-1.568q-2.752 0-4.736 1.952t-1.952 4.672q0 0.48 0.16 1.376l0.416 1.984z"
});

const SvgCloud = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-cloud",
    viewBox: "0 0 34 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud.b7078a93.svg";
export { ForwardRef as ReactComponent };